import { render, staticRenderFns } from "./LinhaDeAditivoResumo.vue?vue&type=template&id=1667d996&scoped=true"
import script from "./LinhaDeAditivoResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeAditivoResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeAditivoResumo.vue?vue&type=style&index=0&id=1667d996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667d996",
  null
  
)

export default component.exports